const React = require('react')
const PropTypes = require('prop-types')
const Query = require('lib/query')
const log = require('log').create('profile') // eslint-disable-line

const ENABLE_MAPPED_NAV = false

function MappedNav({
    mapped,
    owner,
    host,
    template_id,
    luminance,
}) {
    if (! mapped) return null

    const params = {
        owner: owner.user_name,
        template_id,
        luminance,
    }
    const query = Query.stringify(params)

    const url = `${host}/mapped_nav?${query}`

    return ENABLE_MAPPED_NAV && (
        <iframe
            className="nav-frame"
            src={url}
            >
        </iframe>
    )

}

MappedNav.propTypes = {
    mapped: PropTypes.bool.isRequired,
    owner: PropTypes.object.isRequired,
    host: PropTypes.string.isRequired,
    template_id: PropTypes.string.isRequired,
    luminance: PropTypes.string.isRequired,
}

module.exports = MappedNav
